<template>
  <section v-if="$route.query.preview !== 'true'">
    <sweet-modal ref="modal" overlay-theme="dark">
      <div class="text-left">
        <book-cleaner-form @changedParentService="updateParentService"
                           :professional="professional"
                           :from="'bookCleanerModal'"/>
      </div>
    </sweet-modal>
    <div class="button-cleaner-booking-modal">
      <div class="row py-2" v-if="professional.active === 0">
        <div class="col-12 text-danger">
          {{ $t('message.professional.inactive_status') }}
          <hr class="mb-0">
        </div>
      </div>
      <div class="px-4">
        <button class="btn btn-info btn-block btn-lg"
                :disabled="(professional.active === 0)"
                data-toggle="modal"
                data-target="#bookCleanerModal"
                @click="openModal">
          <template v-if="professional.is_favorited_user">
            <i class="fas fa-bolt -status-instant-book -button"></i>
            {{ $t('message.button.instant_book') }}
          </template>
          <template v-else>
            {{ $t('message.button.book') }}
          </template>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
  import BookCleanerForm from './BookCleanerForm'
  import { mapGetters } from 'vuex'
  import { SweetModal } from 'sweet-modal-vue'

  export default {
    props: ['professional'],
    components: {
      BookCleanerForm,
      SweetModal
    },
    data () {
      return {
        parentServiceId: 1,
        childServices: null
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser',
        globalState: 'globalVal/getState'
      })
    },
    methods: {
      updateParentService (callbackData) {
        this.parentServiceId = callbackData.parentServiceId
        this.childServices = callbackData.childServices
      },
      openModal () {
        this.$refs.modal.open()
      },
      closeModal () {
        this.$refs.modal.close()
      },
      openLoginModal () {
        const parent = this.$parent
        parent.$parent.openModal('login')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/professional/components/BookCleanerModal.vue